module.exports = __webpack_public_path__ + "static/water-d5f5b6956c48f8a4e234c4c19ca14f0e.jpg";